module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Italian’s Ruthless Marriage Bargain")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('div', {
    staticClass: "chapterBody"
  }, [_c('br'), _c('br'), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Though lacking much authentic Welsh blood, "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("KIM LAWRENCE")])]), _vm._v("—from English/Irish stock—was born and brought up in north Wales. She returned there when she married, and her sons were both born on Anglesey, an island off the coast. Though not isolated, Anglesey is a little off the beaten track, but lively Dublin, which Kim loves, is only a short ferry ride away.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Today they live on the farm her husband was brought up on. Welsh is the first language of many people in this area, and Kim’s husband and sons are all bilingual. She is having a lot of fun, not to mention a few headaches, trying to learn the language!")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("With small children, the unsocial hours of nursing weren’t too attractive, so, encouraged by a husband who thinks she can do anything she sets her mind to, Kim tried her hand at writing. Always an avid Harlequin"), _c('sup', [_vm._v("®")]), _vm._v(" reader, she felt it was natural for her to write a romance novel. Now she can’t imagine doing anything else.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("She is a keen gardener and cook, and enjoys running—often on the beach, because, since she lives on an island, the sea is never very far away. She is usually accompanied by her Jack Russell, Sprout—don’t ask, it’s a long story!")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-186fd63a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/italiansruthlessmarriagebargainthe_fm02.vue
// module id = 60
// module chunks = 0